import { animate, animation, style } from '@angular/animations';

export const transformScale = animation([
  style({ transform: 'scale({{ xStart }}, {{ yStart }}' }),
  animate('{{ time }} {{ easing }}', style({ transform: 'scale({{ xEnd }}, {{ yEnd }}' })),
]);
